import styled from "styled-components";
import Button from "./Button";

const StyledNavButton = styled(Button)`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;

export default StyledNavButton;
